import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { compose, withState } from 'recompose';

import './style.scss';

const CategoryBlock = ({
  img,
  link,
  hover,
  setHover,
  span,
}) => (
  <Link to={`/${link}`} className="category-block">
    <img className={`category-block__img ${hover ? 'category-block__img__scaled' : ''}`} src={img} alt={span} />
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="category-block__bottom-text"
    >
      <span className="category-block__border-top" />
      <div className="category-block__bottom-text__span"><span>{span}</span></div>
    </div>
  </Link>
);

CategoryBlock.propTypes = {
  img: PropTypes.any.isRequired,
  span: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  hover: PropTypes.bool.isRequired,
  setHover: PropTypes.func.isRequired,
};

export default compose(
  withState('hover', 'setHover', false),
)(CategoryBlock);



// WEBPACK FOOTER //
// ./src/components/ui/CategoryBlock/index.js